import React from 'react';

const AllRacing = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "19",
    height: "18",
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.3663 1.60293C14.3984 1.41033 14.3387 1.21379 14.2048 1.07163C14.071 0.929462 13.8784 0.857999 13.6842 0.878439L13.031 0.947202C8.29255 1.44598 4.13563 4.32673 2.00483 8.58833L0.6875 11.223L1.8058 11.7821L3.12314 9.14748C5.03848 5.3168 8.75194 2.71157 12.9978 2.20898L12.7163 3.89798C12.6798 4.11697 12.7621 4.33889 12.9327 4.48101L17.5535 8.33171L17.5245 8.38985C17.0974 9.24388 16.0969 9.64076 15.2006 9.31167L12.7587 8.41512C12.6267 8.36666 12.4822 8.36411 12.3486 8.40788L12.1135 8.48489C10.8192 8.9089 9.4045 8.7499 8.23656 8.04914L7.59329 9.12126C8.31566 9.55468 9.11258 9.82445 9.92988 9.92446C9.31667 12.3631 9.13002 14.8921 9.38072 17.3991L10.6248 17.2747C10.3786 14.8129 10.5799 12.3287 11.217 9.94161C11.6504 9.90025 12.0816 9.81103 12.5028 9.67306L12.5316 9.66363L14.7697 10.4854C16.2636 11.0338 17.9311 10.3724 18.6428 8.94901L18.8933 8.44801C19.023 8.18853 18.9572 7.8739 18.7343 7.68818L14.0085 3.74997L14.3663 1.60293ZM12.5002 5.66783C12.5002 6.12818 12.127 6.50137 11.6667 6.50137C11.2063 6.50137 10.8331 6.12818 10.8331 5.66783C10.8331 5.20749 11.2063 4.8343 11.6667 4.8343C12.127 4.8343 12.5002 5.20749 12.5002 5.66783Z",
      fill: "white"
    }
  )
);

export { AllRacing };
//# sourceMappingURL=AllRacing.js.map
